<template>
    <span :class="['status-label', 'accounting', statusName, size]">
        <span class="text">
            <span>{{ statusTxt }}</span>
            <span v-if="count !== null" class="count">{{ count }}</span>
        </span>
    </span>
</template>
<script>
import { accountingStatusOptions } from '@/assets/commonData/options';

export default {
    name: 'accounting-status-label',
    props: {
        statusNum: {
            type: Number,
            default: () => 0,
        },
        count: {
            type: Number,
            default: () => null,
        },
        size: {
            type: String,
            default: 'normal',
        },
    },
    computed: {
        statusTxt() {
            const status = accountingStatusOptions.find((s) => s.key === this.statusNum);
            if (status) {
                return status.label;
            }
            return '---';
        },
        statusName() {
            switch (this.statusNum) {
            case 1:
                return 'complete';
            case 2:
                return 'no-accounting-need';
            default:
                return 'wait-for-check';
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting.status-label {
    display: inline-block;
    height: 22px;
    line-height: 22px;
    padding: 0 8px;
    border-radius: 5px;
    background-color: #eee;

    > .text {
        font-size: 9pt;
        font-weight: bold;

        .count {
            opacity: 0.5;
            margin-left: 9px;
            font-weight: bold;
        }
    }

    &.wait-for-check {
        // background-color: #463cb2;
        // color: #fff;
        background-color: #fce7d8;
        color: #ef6401;
    }
    &.complete {
        background-color: #def5d6;
        color: #0baa1b;
    }
    &.no-accounting-need {
        // background-color: #e1e1e1;
        color: #555;
    }
}
</style>
